export default __webpack_public_path__ + "static/brahms-g-moll-201423edb756f9866f9ada2207299230.mp3";